<div class="loading-overlay" *ngIf="loadingService.loading$ | async">
  <div class="spinner-container">
    <img src="assets/img/loading_1.gif" alt="logo" class="logo" />
    <!-- <h1>Loading...</h1> -->
  </div>
</div>
